import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {PspSubscriptionStatusTrackingService} from '../../../_services/PSP/psp-subscription-status-tracking.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {GenericResponse} from '../../../_models/response.model';
import {PspSubscriptionStatusEnum} from '../../../enums/psp-subscription-status-enum';
import {
  GetPspSubscriptionStatusTrackingResponse,
  PspSubscriptionStatusTracking
} from '../../../_models/PSP/psp-subscription-status-tracking.model';

@Component({
  selector: 'app-view-flagging-tracking',
  templateUrl: './view-flagging-tracking.component.html',
  styleUrls: ['./view-flagging-tracking.component.scss']
})
export class ViewFlaggingTrackingComponent implements OnInit, OnDestroy {
  public tracking: PspSubscriptionStatusTracking[];
  public pspSubscriptionStatusEnum: typeof PspSubscriptionStatusEnum = PspSubscriptionStatusEnum;
  private routeSub: Subscription;
  private subscriptionId: number;

  constructor(
      private route: ActivatedRoute,
      private trackingService: PspSubscriptionStatusTrackingService,
      private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe(params => {
      this.subscriptionId = params.subscriptionId;
    });

    this.trackingService
        .getStatusChangeTracking(this.subscriptionId)
        .subscribe(
            response => this.mapTrackingData(response),
            err => this.spinner.hide()
        );
  }

  private mapTrackingData(res: GenericResponse<GetPspSubscriptionStatusTrackingResponse>): void {
    this.tracking = res.data.trackings.filter(t => this.isValidTracking(t));
  }

  private isValidTracking(t: PspSubscriptionStatusTracking): boolean {
    return (t.status.id === PspSubscriptionStatusEnum.Active && t.oldStatus.id === PspSubscriptionStatusEnum.Suspended)
        || t.status.id === PspSubscriptionStatusEnum.Suspended;
  }

  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
  }
}
